module.exports = __webpack_public_path__ + "static/media/banner3.785c475f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interiors/banner3.jpg
// module id = 196
// module chunks = 0